<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible="showProcessLibDialog"
      @close="closeDialog"
      width="58%"
    >
      <template v-if="showProcessLibDialog">
        <div>
          <div class="bottom" style="width: 100%; display: flex;">
            <div style="flex: 1" class="lists left">
              <div class="search-group" style="padding-bottom: 10px; border-bottom: 2px solid #c4c4c4;">
                <div class="input-box" style="float: left">
                  <el-input
                    size="mini"
                    placeholder="请输入模版名称"
                    v-model="searchProcessTemplate.templateName">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
                <el-button style="margin-left: 10px" type="primary" size="mini" @click="doProcessTemplateSearch">{{ "搜索" }}</el-button>
              </div>
              <div class="list-box" style="margin-top: 10px" v-loading="processTemplateDataLoading">
                <div class="list flex-between list-title" style="width: 380px">
                  <span style="width: 25px"></span>
                  <span style="width: 100px">模版名称</span>
                </div>
                <el-radio-group v-model="activeProcessTemplateIndex">
                  <div style="width: 380px" class="list flex-between" :key="item.id" v-for="(item, index) in processTemplateData">
                  <span style="width: 25px">
                    <el-radio :label="index"></el-radio>
                  </span>
                    <span style="width: 100px">{{ item.templateName }}</span>
                  </div>
                </el-radio-group>
              </div>
              <div class="page-box">
                <el-pagination
                  @current-change="handleProcessTemplateCurrentChange"
                  :current-page.sync="pageProcessTemplateNo"
                  size="mini"
                  :pager-count="5"
                  :page-size="pageProcessTemplateSize"
                  layout="prev, pager, next"
                  :total="pageProcessTemplateSizeTotal"
                >
                </el-pagination>
              </div>
            </div>
            <div style="flex: 1" class="lists right">
              <div class="search-group" style="padding-bottom: 10px; border-bottom: 2px solid #c4c4c4;">
                <div class="input-box" style="float: left">
                  <el-input
                    size="mini"
                    placeholder="请输入订单号、名称"
                    v-model="searchWorkshopOrderAndUnit.workshopUnitName">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </div>
                <el-button style="margin-left: 10px" type="primary" size="mini" @click="doWorkshopOrderAndUnitSearch">{{ "搜索" }}</el-button>
              </div>
              <div class="list-box" style="margin-top: 10px;" v-loading="workshopOrderAndUnitDataLoading">
                <div class="list flex-between list-title" style="width: 450px">
                  <span style="width: 25px"></span>
                  <span style="width: 120px">订单号</span>
                  <span style="width: 220px">订单名称</span>
                </div>
                <el-radio-group v-model="activeWorkshopOrderAndUnitIndex">
                  <div style="width: 450px" class="list flex-between" :key="item.id" v-for="(item, index) in workshopOrderAndUnitData">
                  <span style="width: 25px">
                    <el-radio :label="index"></el-radio>
                  </span>
                    <span style="width: 120px">{{ item.numbering }}</span>
                    <span style="width: 220px">{{ item.workshopUnitName}}</span>
                  </div>
                </el-radio-group>
              </div>
              <div class="page-box">
                <el-pagination
                  @current-change="handleWorkshopOrderAndUnitCurrentChange"
                  :current-page.sync="pageWorkshopOrderAndUnitNo"
                  size="mini"
                  :pager-count="5"
                  :page-size="pageWorkshopOrderAndUnitSize"
                  layout="prev, pager, next"
                  :total="pageWorkshopOrderAndUnitSizeTotal"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <el-button :loading="bindLoading" style="width: 100%" type="primary" size="mini" @click="checkBind">绑定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="bindTitle"
      :visible="showChildProcessDialog"
      @close="closeChildProcessDialog"
      width="60%"
    >
      <template v-if="showChildProcessDialog">
        <div>
          <el-table
            :data="tableData"
            border
            v-loading="tableDataLoading"
            :cell-style="cellStyle"
            :header-cell-style="tableHeaderStyle"
            :span-method="objectSpanMethod"
            style="width: 100%;">
            <el-table-column
              v-for="column in columns"
              :key="column.prop"
              :prop="column.prop"
              :label="column.label"
              :width="column.width"
              :formatter="column.formatter"
            ></el-table-column>
          </el-table>
          <el-button key="autoButton"
                     :loading="submitLoading"
                     :disabled="isDisabled"
                     style="width: 100%; margin-top: 20px"
                     type="primary" size="mini" @click="submitBind">提交</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    showProcessLibDialog: Boolean,
    workshopProjectId: String,
    title: {
      type: String,
      default: "工序模版库",
    }
  },
  watch: {
    activeProcessTemplateIndex: {
      handler() {

      },
      deep: true,
    },
    activeWorkshopOrderAndUnitIndex: {
      handler() {

      },
      deep: true,
    }
  },
  data() {
    return {
      start: 0,
      bindTitle: '',
      templateName: '',
      isDisabled: false,
      bindLoading: false,
      submitLoading: false,
      tableDataLoading: false,
      showChildProcessDialog: false,
      activeProcessTemplateIndex: '',
      activeWorkshopOrderAndUnitIndex: '',

      processTemplateData: [],
      processTemplateDataLoading: true,

      workshopOrderAndUnitData: [],
      workshopOrderAndUnitDataLoading: true,

      pageProcessTemplateNo: 1,
      pageProcessTemplateSize: 5,
      pageProcessTemplateSizeTotal: 1,

      pageWorkshopOrderAndUnitNo: 1,
      pageWorkshopOrderAndUnitSize: 5,
      pageWorkshopOrderAndUnitSizeTotal: 1,
      searchProcessTemplate: {
        pageNo: "",
        pageSize: "",
        templateName: ""
      },
      searchWorkshopOrderAndUnit: {
        pageNo: "",
        pageSize: "",
        workshopUnitName: "",
        workshopProjectId: ""
      },
      tableData: [],
      spanArr: [],
      columns:[
        {
          prop:'processName',
          label:'阶段',
          width:'150'
        },
        {
          prop:'fakeEstimatedWorkingHours',
          label:'总工时',
          width:'80',
          formatter: (row) => {
            return row.estimatedWorkingHours;
          }
        },
        {
          prop:'content',
          label:'工序',
        },
        {
          prop:'standardWorkingHours',
          label:'标准工时',
          width:'80'
        },
        {
          prop:'limitWorkingHours',
          label:'上限工时',
          width:'80'
        },
        {
          prop:'fakeTotalStandardWorkingHours',
          label:'合计标准',
          width:'80',
          formatter: (row) => {
            return row.totalStandardWorkingHours;
          }
        }
      ]
    };
  },
  methods: {
    initActiveIndex() {
      this.activeProcessTemplateIndex = "";
      this.activeWorkshopOrderAndUnitIndex = "";
    },
    closeDialog() {
      this.$emit("update:showProcessLibDialog", false);
    },
    closeChildProcessDialog() {
      this.isDisabled = false;
      this.showChildProcessDialog = false;
    },
    doProcessTemplateSearch() {
      this.initActiveIndex();
      this.getProcessTemplateData();
    },
    doWorkshopOrderAndUnitSearch() {
      this.initActiveIndex();
      this.getWorkshopOrderAndUnitData()
    },
    handleProcessTemplateCurrentChange(res) {
      this.activeProcessTemplateIndex = "";
      this.pageProcessTemplateNo = res;
      this.getProcessTemplateData();
    },
    handleWorkshopOrderAndUnitCurrentChange(res) {
      this.activeWorkshopOrderAndUnitIndex = "";
      this.pageWorkshopOrderAndUnitNo = res;
      this.getWorkshopOrderAndUnitData();
    },
    getProcessTemplateData() {
      this.processTemplateDataLoading = true;
      let data = this.searchProcessTemplate;
      data.pageNo = this.pageProcessTemplateNo;
      data.pageSize = this.pageProcessTemplateSize;
      this.ccRequest
        .do('admin/fsb/process/template/query', data, 'GET')
        .then((res) => {
          this.processTemplateDataLoading = false;
          this.processTemplateData = res.rows;
          this.pageProcessTemplateSizeTotal = res.total;
        });
    },
    getWorkshopOrderAndUnitData() {
      this.workshopOrderAndUnitDataLoading = true;
      let data = this.searchWorkshopOrderAndUnit;
      data.pageNo = this.pageWorkshopOrderAndUnitNo;
      data.pageSize = this.pageWorkshopOrderAndUnitSize;
      data.workshopProjectId = this.workshopProjectId;
      this.ccRequest
        .do('admin/fsb/process/bind/queryWorkshopUnit', data, 'GET')
        .then((res) => {
          this.workshopOrderAndUnitDataLoading = false;
          this.workshopOrderAndUnitData = res.rows;
          this.pageWorkshopOrderAndUnitSizeTotal = res.total;
        });
    },
    checkBind() {
      if (this.activeProcessTemplateIndex === '') {
        this.$message.error('请选择模版');
        return false;
      }
      if (this.activeWorkshopOrderAndUnitIndex === '') {
        this.$message.error('请选择订单');
        return false;
      }
      this.bindTitle = this.workshopOrderAndUnitData[this.activeWorkshopOrderAndUnitIndex].workshopUnitName
        + '[数量x'+this.workshopOrderAndUnitData[this.activeWorkshopOrderAndUnitIndex].workshopUnitNum+']'
        + ' ↹ ' +  this.processTemplateData[this.activeProcessTemplateIndex].templateName;
      this.bindLoading = true;
      this.tableDataLoading = true;
      this.showChildProcessDialog = true;
      if (this.activeProcessTemplateIndex !== '' && this.activeWorkshopOrderAndUnitIndex !== '') {
        this.ccRequest
          .do('admin/fsb/process/bind/queryBind', {
            'processTemplateId': this.processTemplateData[this.activeProcessTemplateIndex].id,
            'workshopUnitId': this.workshopOrderAndUnitData[this.activeWorkshopOrderAndUnitIndex].workshopUnitId
          }, 'POST').then((res) => {
            this.bindLoading = false;
            this.tableDataLoading = false;
            this.tableData = res.data;
            this.setIsDisabled(this.tableData);
            this.getSpanArray(this.tableData, this.columns);
          });
      }
    },
    setIsDisabled(data) {
      if (data.length === 0) {
        this.isDisabled = true;
        return ;
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].estimatedWorkingHours < data[i].totalStandardWorkingHours || data[i].content.length === 0) {
          this.isDisabled = true;
          break;
        }
      }
    },
    submitBind() {
      this.ccRequest
        .do('admin/fsb/process/bind/save', {
          'processTemplateId': this.processTemplateData[this.activeProcessTemplateIndex].id,
          'workshopUnitId': this.workshopOrderAndUnitData[this.activeWorkshopOrderAndUnitIndex].workshopUnitId
        },'POST').then(() => {
          this.$message({message: "提交成功", type: "success"});
          this.showChildProcessDialog = false;
          this.closeDialog();
          this.$emit('doSearch2');
        }).catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    getSpanArray(data, columns) {
      this.spanArr = [];
      const arr = columns.map((e) => e.prop);
      const nameObj = new Array(arr.length).fill(0);
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr[0] = new Array(arr.length).fill(1);
          nameObj[0] = 0;
        } else {
          let newRow = [];
          for (let j = 0; j < arr.length; j++) {
            if (data[i][arr[j]] === data[i - 1][arr[j]] && (arr[j] === 'processName' || arr[j] === 'fakeEstimatedWorkingHours' || arr[j] === 'fakeTotalStandardWorkingHours')) {
              this.spanArr[nameObj[j]][j] += 1;
              newRow.push(0);
            } else {
              newRow.push(1);
              nameObj[j] = i;
            }
          }
          this.spanArr.push(newRow);
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const _row = this.spanArr[rowIndex][columnIndex];
      const _col = _row > 0 ? 1 : 0;
      return { rowspan: _row, colspan: _col };
    },
    cellStyle(data) {
      if (data.row.totalStandardWorkingHours > data.row.estimatedWorkingHours || data.row.content.length === 0) {
        return { "background-color": "#FFB6C1 !important" };
      }
    },
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-color: #F5F7FA; color: #6f6f6f';
    }
  },
  mounted() {
    this.getProcessTemplateData();
    this.getWorkshopOrderAndUnitData();
  }
};
</script>
<style scoped lang="scss">
.lists {
  .list-box {
    .list {
      justify-content: flex-start;
      padding: 10px;
      color: #c2c2bf;
      font-size: 12px;
      border-bottom: 1px dotted #b1b1b1;
      > * {
        margin-right: 10px;

        &:last-child {
          margin-right: 0;
          flex: 1;
        }
      }

      &.list-title {
        font-size: 14px;
        border-bottom: none;
        background: #f3f3f4;
        color: #6f6f6f;
      }
    }
  }
  &.left {
    display: inline;
    padding-right: 10px;
    .list {
      width: 250px;
      position: relative;

    }
  }
  &.right {
    display: inline;
    padding-left: 10px;
    border-left: 5px solid #f3f3f4;
    .list-box {
      .list {
        width: 250px;
        position: relative;
      }
    }
  }
}
::v-deep .el-radio__label {
  opacity: 0 !important;
}

::v-deep .el-dialog__body {
  padding: 0 20px 30px 20px;
}

::v-deep .el-table .el-table__cell {
  padding: 6px 0;
}

::v-deep .el-table .el-table__body tr:hover > td {
  background-color: inherit;
}
</style>
